<template>
  <m-card207
      :image="product.thumbnail"
      :alt="product.name"
      class="product-card-207-modal "
  >
    <template #p-1>
      <p class="p-0 m-0">{{ contentSlicer(product.name, 55) }}</p>
    </template>
    <template #p-2>
      <div class=""></div>
    </template>

    <template #p-3>
      <m-product-price300 class="text-center mb-3 product-card-312-price" :product="product"/>

      <div class="card207-icon btn radius-class bg-danger p-1 font-weight-bold w-75 text-white"
           data-toggle="modal" :data-target="`#product-card-207-modal-${product.id}`"
           v-t="`product.add_to_cart_physical`">
      </div>

      <!-- Modal -->
      <teleport to="body">
        <div class="modal bottom fade " :id="`product-card-207-modal-${product.id}`" tabindex="-1" role="dialog"
             aria-labelledby="bottomModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <div class="product-content">
                  <div class=" product-content-gallery">
                    <single-product-gallery2 class="col-12" :product="product"/>
                  </div>

                  <div class="col-12 text-right">
                    <h5>{{ product.name }}</h5>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <p>برند</p>
                      <p class="mx-1 d-inline-block p-0 m-0 font-weight-bold" v-if="product.brand">{{
                          product.brand.name
                        }}</p>
                    </div>
                    <div class="col-6">
                      <p>دسته بندی</p>
                      <p class="mx-1 d-inline-block p-0 m-0 font-weight-bold" v-for="category in product.category">
                        {{ category.name }}</p>
                    </div>
                  </div>

                  <hr>

                  <div class="col-lg-6 col-12 mx-auto my-3">

                    <template v-if="product.variation == 1" v-for="feature in productFeatureSubProduct(product)">
                      <ProductCard208PriceManager class="product-card-200-price-manager-wrapper"
                                                  :show-trash-only-in-first-quantity="true"
                                                  :product="product"
                                                  :feature="feature"/>
                    </template>
                    <ProductCard208PriceManager :show-trash-only-in-first-quantity="true"
                                                class="product-card-200-price-manager-wrapper" v-else
                                                :product="product"/>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </teleport>

    </template>
  </m-card207>
</template>

<script>
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mCard207 from "../../Cards/Card207";
import mA from "../../Tags/A";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice300 from "../../Product/ProductPrice300";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from "../ProductOffer/ProductOfferProps";
import {
  findFeatureWithSelectedName, productFeatureSubProduct,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import SingleProductGallery2 from "../../Product/Single/Components/SingleProductGallery1.vue";
import ProductCard208PriceManager from "../../Product/Card/ProductCard208/ProductCard208PriceManager.vue";
import $ from 'jquery'

export default {
  name: "ProductCard207Modal",
  components: {
    ProductCard208PriceManager,
    SingleProductGallery2,
    mCard207,
    mA,
    mProductCardQuantityManager1,
    mProductPrice300,
    mProductOffer1,
  },

  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    productFeatureSubProduct,
    contentSlicer,
    ...shoppingCartFunctions,
    findFeatureWithSelectedName,
  },
  beforeUnmount() {
    $(`#product-card-207-modal-${this.product.id}`).modal('hide')
  }
};
</script>

<style scoped>
.modal.bottom .modal-dialog {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  transition: transform 0.3s ease-out;
  width: 100%;
}

.modal.bottom.show .modal-dialog {
  transform: translate(-50%, 0);
}

.product-content-gallery {
  height: 150px;
}

.product-content-gallery :deep(.single-product-gallery-1) {
  height: 150px !important;
}

.product-content-gallery :deep(.gallery-thumbs) {
  display: none;
}

</style>
